import React from "react";
import {Blocks} from "./assets/Blocks";
import {ThemeProvider} from "../../state";
import {client} from "../../../Infrastructure/models/client";
import {QueryClientProvider} from "@tanstack/react-query";
import {FooterInfo} from "./assets/FooterInfo";
import {FooterLinks} from "./assets/FooterLinks";
import {TranslationsProvider} from "../../../../general/i18n/Translations";

const queryClient = client();

export const FooterContainer = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <TranslationsProvider>
                    <div className="footer-menu">
                        <Blocks/>
                        <FooterInfo />
                        <FooterLinks />
                    </div>
                </TranslationsProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}